import { useMemo} from "react";
import {UIProps} from "../../types";

export default function AlphaAvatar({
                                        name,
                                        size = "default", className = '',style}: {
    name: string,
    size?: number|"sm"|"default"|"lg",
}&UIProps) {

    const avatar = useMemo(()=>{
        if (name) {
            const char = name[0].toUpperCase()
            if (char.match(/[a-zA-Z0-9]/)) {
                return char
            }
        }
        return ''
    },[name])

    const numberSize = typeof size === 'number' ? size : size === 'sm' ? 24 : size === 'default' ? 40 : 64
    return <div className={`matchid-alpha-avatar ${className}`} style={{
        width: numberSize,
        height: numberSize,
        fontSize: Math.ceil(numberSize / 2),
        ...style
    }}>
        {avatar}
    </div>
}